import React from 'react';
import {Grid, Typography, Card, CardContent, Paper} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const multiplyMatrices = (A, B, modulus) => {
    let result = new Array(A.length).fill(0).map(row => new Array(B[0].length).fill(0));
    for (let i = 0; i < A.length; i++) {
        for (let j = 0; j < B[0].length; j++) {
            for (let k = 0; k < A[0].length; k++) {
                result[i][j] += (A[i][k] * B[k][j]) % modulus;
                result[i][j] %= modulus;
            }
        }
    }
    return result;
};

export const MatrixDisplay = ({ matrix, title }) => (
    <Grid item >
        <Paper style={{ margin: '10px', padding: '10px', backgroundColor: '#e3f2fd' } }>
            <Typography variant="h6">{title}</Typography>
            <Grid container spacing={1}>
                {matrix.map((row, i) => (
                    <Grid key={i} container item xs={12} spacing={1}>
                        {row.map((val, j) => (
                            <Grid key={`${i}-${j}`} item xs={6}>
                                <Paper style={{ padding: '5px', textAlign: 'center' }}>{val}</Paper>
                            </Grid>
                        ))}
                    </Grid>
                ))}
            </Grid>
        </Paper>
    </Grid>
);

export const MatrixPairDisplay = ({ M, N, textM, textN, textMTimesN, modulus }) => {
    const product = multiplyMatrices(M, N, modulus);

    return (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', width: '100%', }}> {/* Centering the card */}
            <Card style={{ width: '90%', backgroundColor: '#85a1bb' }}>
                <CardContent style={{ padding: '4px' }}>
                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        <Grid item xs={3}>
                            <MatrixDisplay matrix={M} title={textM} />
                        </Grid>
                        <Grid item xs={1}>
                            <Typography variant="h4" style={{ display: 'flex', justifyContent: 'center' }}><CloseIcon /></Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <MatrixDisplay matrix={N} title={textN} />
                        </Grid>
                        <Grid item xs={1}>
                            <Typography variant="h4" style={{ display: 'flex', justifyContent: 'center' }}>=</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <MatrixDisplay matrix={product} title={textMTimesN + " % "+ modulus} />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
};

